import { secureRoutes } from "../routes";
import {
  isRestrictedCompanyManager,
  isRestrictedCompanyManagerBlockedPath,
} from "../userRoleAccess";

/**
 * Sidebar / Add New visibility: role + restricted company manager only.
 * Plan gating runs in app-route (evaluateRouteAccess) and page-level checks.
 */
export function canShowNavMenuPath(path, userProfile, effectiveRoles = []) {
  if (!path || /^https?:\/\//i.test(String(path))) return true;
  if (
    isRestrictedCompanyManager(userProfile) &&
    isRestrictedCompanyManagerBlockedPath(path)
  ) {
    return false;
  }
  const matchedRoute = secureRoutes?.find((route) => route?.path === path);
  if (!matchedRoute || !Array.isArray(matchedRoute?.roles)) return true;
  return effectiveRoles.some((role) => matchedRoute.roles.includes(role));
}
